/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .filter-header[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;padding:0 25px;color:#2f384f;margin-bottom:20px;font-weight:500}"];
export { styles as styles };
